import { DataTableDefinition } from "@/v2/types/Datatable";
import { createColumnHelper, flexRender } from "@tanstack/react-table";
import { buildColumns } from "./buildColumns";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Eye, Pencil } from "lucide-react";
import { Client } from "@/v2/types";
import { generateFilterColumn } from "../../filter";
import ClientDeleteButton from "../../ui/button/delete/Client";
import AccessControl from "../../rbac/AccessControl";

type T = Client;

const columnHelper = createColumnHelper<T>();

const ClientsColumnDefintion: DataTableDefinition<T>[] = [
    {
        id: "sl",
        headingText: "Sl No",
        headingCellType: "small-cell",
        cellType: "text-center",
    },
    {
        id: "full_name",
        headingText: "Client Name",
        headingCellType: "text-center",
    },

    {
        id: "short_code",
        headingText: "Short Code",
        headingCellType: "text-center",
        cellType: "text-center",
    },
    {
        id: "email",
        headingText: "Email",
        headingCellType: "text-center",
        cellType: "text-center",
    },
    {
        id: "phone_number",
        headingText: "Phone Number",
        headingCellType: "text-center",
        cellType: "text-center",
    },
    {
        id: "representatives.full_name",
        headingText: "( name )",
        headingCellType: "representative",
        cell: ({ row }) => {
            return (
                <div className="text-left">
                    {row.representatives?.at(0)?.full_name}
                </div>
            );
        },
    },
    {
        id: "representatives.phone_number",
        headingText: "( number )",
        headingCellType: "representative",
        cell: ({ row }) => {
            return (
                <div className="text-left">
                    {row.representatives?.at(0)?.phone_number}
                </div>
            );
        },
    },
    {
        id: "representatives.email",
        headingText: "( email )",
        headingCellType: "representative",
        cell: ({ row }) => {
            return (
                <div className="text-left">
                    {row.representatives?.at(0)?.email}
                </div>
            );
        },
    },
    {
        id: "locations",
        headingText: "Location",
        headingCellType: "text-center",
        cell: ({ row }) => {
            return (
                <div className="min-w-[300px]">
                    {row.locations?.map((location) => (
                        <p key={location}>{location}</p>
                    ))}
                </div>
            );
        },
    },

    {
        id: "assigned_client",
        headingText: "Coordinator",
        headingCellType: "text-center",
        cell: ({ row }) => {
            return (
                <div className="text-center">
                    {row.assigned_client?.map((assignedClient) => (
                        <p key={assignedClient.id}>
                            {assignedClient.full_name}
                        </p>
                    ))}
                </div>
            );
        },
    },

    {
        id: "actions",
        headingText: "Actions",
        headingCellType: "text-center",
        cell: ({ row }) =>
            flexRender(
                <div className="flex justify-center gap-2">
                    <Link to={`/client-database/${row.id}`}>
                        <Button variant={"outline"} size={"sm"}>
                            <Eye className="size-4" />
                        </Button>
                    </Link>

                    <AccessControl
                        module="CLIENT_MANAGEMENT"
                        requestedAccess={"PUT"}
                    >
                        <Link to={`/client-database/edit/${row.id}`}>
                            <Button variant={"outline"} size={"sm"}>
                                <Pencil className="size-4" />
                            </Button>
                        </Link>
                    </AccessControl>

                    <AccessControl
                        module="CLIENT_MANAGEMENT"
                        requestedAccess={"DELETE"}
                    >
                        <ClientDeleteButton id={row.id} />
                    </AccessControl>
                </div>,
                {},
            ),
    },
];

const ClientsColumn = buildColumns<T>(columnHelper, ClientsColumnDefintion);

const ClientsFilterColumn = generateFilterColumn<T>(ClientsColumnDefintion, {
    removeIds: ["full_name_ar"],
    renameMap: {
        "representatives.full_name": "Representative Name",
        "representatives.email": "Representative Email",
        "representatives.phone_number": "Representative Phone Number",
    },
    addFilterId: {
        assigned_client: "assigned_clients.full_name",
    },
});

export { ClientsColumn, ClientsFilterColumn };
